import React, { useState } from 'react';
import moment from 'moment';

const EventsDates = (props) => {
    let eventFromDate = moment(props?.from_date).format("MMMM Do YYYY");
    let eventToDate = moment(props?.to_date).format("MMMM Do YYYY");
    let showEventDate = moment(props?.event_date).format("MMMM Do YYYY");
    if(eventFromDate && eventToDate && eventFromDate !== eventToDate) {
        showEventDate = eventFromDate + " - " + eventToDate;
    }
    return (
        <div className="event-date">
            <div className="wrap-icon">
                <i className="icon-calendar"></i>
            </div>
            {showEventDate}
        </div>
    );
}
export default EventsDates;